import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadLiterals } from '../../redux/reducers';
import loadLang from '../../i18n/i18n';
// import WebChatHeader from '../WebChatHeaderComponent/WebChatHeader';
import WelcomeScreen from '../WelcomeScreenComponent/WelcomeScreenComponent';
import WebChat from '../WebChatComponent/WebChat';
import { ENGLISH, ARABIC } from '../../shared/supportedLanguages';
import { APPLICATION_JSON } from '../../shared/sharedConsts';
import './MainWindow.css';
// import CloseChatComponent from "../CloseChatComponent/CloseChatComponent";

class MainWindow extends Component {
	constructor(props) {
		super(props);
		let size = window.parent != null ? { height: window.parent.outerHeight, width: window.parent.outerWidth } : { height: window.outerHeight, width: window.outerWidth };
		const initialHeight = 570; // "60%";
		// var locale = ENGLISH;

		let botLang;
		if (localStorage.getItem('botLang') != null) {
			var locale = localStorage.getItem('botLang');
			localStorage.setItem('botLang', locale);
			botLang = locale;
		}
		else {
			var locale = ENGLISH;
			localStorage.setItem('botLang', locale);
			botLang = locale;
		}
		localStorage.removeItem('botToken');

		this.WebChatRef = React.createRef();

		// if (!!props.searchParameters['locale'])
		// 	if (props.searchParameters['locale'].indexOf('ar') >= 0)
		// 		locale = ARABIC;

		this.state = {
			token: null,
			language: locale,
			welcomedUser: true,
			chatWindowHeight: initialHeight,
			height: initialHeight,
			initialHeight: initialHeight,
			noOfbuttonPressed: 0,
			showedIntroCard: false,
			size: size,
			webChatConfiguration: '',
			soundMuted: false,
			webSpeechPonyfillFactory: null,
			finishedLoading: false,
			isUserLogged: false,
			queueData: null
		};

		this.updateQueuePosition();
	}

	componentDidMount = async () => {
		if (!this.state.webChatConfiguration) {
			const response = await fetch(
				"./webChatConfiguration.json",
				{
					headers: {
						'Content-Type': APPLICATION_JSON,
						'Accept': APPLICATION_JSON
					}
				}
			).catch(function () {
				// Handle error if needed
				this.setState({ finishedLoading: true });
				return;
			});

			const data = await response.json();
			this.setState({ webChatConfiguration: data, finishedLoading: true });
		}
	}

	startBotWithLanguage = (language) => {
		this.locale = language;
		this.language = language;
		//alert('begin startBotWithLanguage : ' + language);
		loadLang(language).then(lang => this.props.dispatch(loadLiterals(lang)));
		this.setState({ language: language }, () => { this.setState({ welcomedUser: true }) })
		this.changeLanguage(language);
		//alert('end startBotWithLanguage : ' + language);

	}

	handleWindowChangedHeight = () => {
		window.parent.dispatchEvent(new CustomEvent('ChatbotResizeNeeded'), {})
	};
	handleCloseButtonClicked = () => {
		window.parent.dispatchEvent(new CustomEvent('Minimize'), {});
	};

	// Handle Back
	handleBackButtonClick = () => {
		debugger;
		this.setConversationAsAbandon();
		setTimeout(() => {
			this.setState({ token: null, showedIntroCard: false, welcomedUser: false }, () => {
				window.parent.dispatchEvent(new CustomEvent('ChatbotBackClicked'), {});
			});

			this.handleDequeued(null);
			this.diconnect();
			this.navigateToWelcome();
		}, 200);
	};


	handleShowedIntroCard = () => {
		this.setState({ showedIntroCard: true });
	}
	handleQueueDataRecieved = (data) => {
		this.setState({ queueData: data });
	}
	handleDequeued = (data) => {
		this.setState({ queueData: null });
	}

	handleRestartButtonClick = (event) => {
		setTimeout(() => {
			//var lang = this.state.language;
			var lang = localStorage.getItem('botLang');
			if (!!event && !!event.target && !!event.target.value) {
				lang = event.target.value;
			}
			this.setState({ token: null, showedIntroCard: false, welcomedUser: false }, () => {
				window.parent.dispatchEvent(new CustomEvent('ChatbotRestartClicked', { detail: {} }))
				this.clearTokens();
				this.startBotWithLanguage(lang);
			});
			// this.handleDequeued(null); 
			//this.diconnect();
			this.showRefresh();
			this.checkQueuePosition();
		}, 100);

	}

	showRefresh = () => {
		this.WebChatRef.showRefresh();
	}

	diconnect = () => {
		this.WebChatRef.disconnectChatbotHandler()
	}

	checkQueuePosition = () => {
		this.WebChatRef.checkQueuePosition();
	}

	setConversationAsAbandon = () => {
		debugger;
		this.WebChatRef.setConversationAsAbandon();
	}

	isQueueWaitingVisiable = () => {
		if (this.state.queueData && this.state.queueData.QueuePosition > 0) {
			return true;
		}
		else
			return false;
	}

	updateQueuePosition = () => {
		setInterval(() => {
			if (this.isQueueWaitingVisiable())
				this.checkQueuePosition();
		}, 20000);
	}

	handleSelectLanguageChanged = (event) => {
		this.handleRestartButtonClick(event);
	}
	changeLanguage = (language) => {
		this.setState({ language: language });
	}
	updateDimensions = () => {
		let size = window.parent != null ? { height: window.parent.outerHeight, width: window.parent.outerWidth } : { height: window.outerHeight, width: window.outerWidth };
		this.setState({ size: size });
	}
	handleToggleMuteSound = () => {
		this.setState({ soundMuted: !this.state.soundMuted })
	}


	// Set User Logged
	setUserLogged = (lang) => {
		//alert('begin setUserLogged : ' + lang);
		let isUserLogged = true;
		this.setState({ isUserLogged: isUserLogged, language: lang })
		window.parent.dispatchEvent(new CustomEvent('ChangeChatWidth', { detail: { width: '450px' } }), {});
		//alert('end setUserLogged : ' + lang);
	}

	// Clear Tokens
	// clearTokens = () => {
	clearTokens() {
		// if (localStorage.getItem('botToken')) {
		// 	localStorage.removeItem('botToken');
		// 	localStorage.removeItem('preflightSent');
		// 	localStorage.removeItem('botLang');
		// }
		localStorage.clear();
	}

	// Navigate To Welcome
	navigateToWelcome = () => {
		let isUserLogged = false;
		this.setState({ isUserLogged: isUserLogged, language: localStorage.getItem('botLang') })
		this.clearTokens();
		window.parent.dispatchEvent(new CustomEvent('ChangeChatWidth', { detail: { width: '350px' } }), {});
	}

	addPlaceholderInTextBox() {
		let textBox = document.querySelectorAll('[data-id="webchat-sendbox-input"]');
		if (textBox[0]) {
			let mains = document.getElementsByClassName("main")[0];
			if (this.state.language.includes("ar")) {
				textBox[0].placeholder = "اكتب رسالتك";
				mains.style.direction = 'rtl';
				// textBox[0].style.direction = 'rtl';
				// textBox[0].style.setProperty('margin-right','10%');
			}
			else {
				textBox[0].placeholder = "Press here to write your message..."
				mains.style.direction = 'ltr';
				//textBox[0].style.direction = 'ltr';
			}

		}
	}

	componentDidUpdate() {
		//if (!this.state.language.includes("ar"))
		this.addPlaceholderInTextBox()

		// if (!localStorage.getItem('botLang').includes("ar"))
		// 	this.addPlaceholderInTextBox()

		this.clearCache();
	}

	clearCache = () => {
		window.parent.dispatchEvent(new CustomEvent("ClearCache", { bubbles: true, detail: {} }));
	}

	render() {
		const {
			state: { token, welcomedUser, language, showedIntroCard, webChatConfiguration, finishedLoading, size, soundMuted, webSpeechPonyfillFactory, isUserLogged },
			startBotWithLanguage,
			handleWindowChangedHeight,
			handleCloseButtonClicked,
			handleBackButtonClick,
			handleShowedIntroCard,
			handleQueueDataRecieved,
			handleDequeued,
			handleRestartButtonClick,
			changeLanguage,
			handleSelectLanguageChanged,
			handleToggleMuteSound,
			setUserLogged,
			disconnectChatbotHandler,
			diconnect
		} = this;
		let mainClassName = "chat-box";

		// var mainWindow = (webChatConfiguration.showWelcomeScreen ? (
		var mainWindow = (!isUserLogged ? (
			<WelcomeScreen className={'welcomeScreen'} startBotWithLanguage={(lang) => startBotWithLanguage(lang)} onOpenChat={this.setUserLogged} />
		) : (
			<div className={mainClassName} dir={getSearchParameters().indexOf('ar') >= 0 ? "rtl" : "ltr"}>
				{/* <WebChatHeader
					size={this.state.size}
					onWindowChangedHeight={handleWindowChangedHeight}
					onBackButtonClicked={handleBackButtonClick}
					onCloseButtonClicked={handleCloseButtonClicked}
					onRestartButtonClicked={handleRestartButtonClick}
					showedIntroCard={showedIntroCard}
					webChatConfiguration={webChatConfiguration}
					onSelectLanguageChanged={handleSelectLanguageChanged}
					onToggleMuteSound={handleToggleMuteSound}
					soundMuted={soundMuted}
					language={getSearchParameters(this.state.language)}
					changeLanguage={changeLanguage}
					queueData={this.state.queueData}
					disconnectChatbotHandler={diconnect}
				/> */}
				<WebChat
					size={size}
					className={'web-chat'}
					token={token}
					//language={getSearchParameters(this.state.language)}
					language={localStorage.getItem('botLang')}
					changeLanguage={changeLanguage}
					showedIntroCard={showedIntroCard}
					handleShowedIntroCard={handleShowedIntroCard}
					handleQueueDataRecieved={handleQueueDataRecieved}
					handleDequeued={handleDequeued}
					webSpeechPonyfillFactory={webSpeechPonyfillFactory}
					webChatConfiguration={webChatConfiguration}
					soundMuted={soundMuted}
					forwardedRef={(el) => this.WebChatRef = el}
				/>
			</div>
		)
		);
		return (!finishedLoading ? <div></div> : mainWindow);
	}
}

const mapStateToProps = ({ literals }) => ({
	literals,
});

var getSearchParameters = (lang) => {
	var match,
		pl = /\+/g,  // Regex for replacing addition symbol with a space
		search = /([^&=]+)=?([^&]*)/g,
		decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
		query = window.location.search.substring(1);

	var urlParams = {};
	while (match = search.exec(query))
		urlParams[decode(match[1])] = decode(match[2]);

	// if (!urlParams.locale)
	// 	return ENGLISH;

	// if (urlParams.locale.indexOf('ar') >= 0) {
	// 	return ARABIC
	// }

	// if (urlParams.locale.indexOf('en') >= 0) {
	// 	return ENGLISH
	// }
	urlParams.locale = lang ? lang : ENGLISH;
	document.getElementsByTagName("html")[0].lang = urlParams.locale.indexOf('ar') >= 0 ? "ar" : "en";
	var chatBox = document.getElementsByClassName('chat-box')[0];
	if (chatBox)
		chatBox.dir = urlParams.locale.indexOf('ar') >= 0 ? "rtl" : "ltr"
	return urlParams.locale;
};

export default connect(mapStateToProps)(MainWindow);